import { createGlobalStyle } from 'styled-components'

export const AnimatedKeyframes = createGlobalStyle`
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`
